var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_c('div',{attrs:{"hidden":""}},[_vm._v("AUTH "+_vm._s(_vm.setter))]),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }